import { Title } from "@/components/ui/Title.ts";
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { IoChevronForward } from "react-icons/io5";
import { ContainerIgnorePadding } from "@/layouts/DashboardLayout.styles.ts";
import { DocEditor } from "@/pages/assistants/FilesInScenario/DocEditor.tsx";
import { stepApi } from "@/api/step.ts";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Step } from "@/types/assistants.ts";
import { useAppDispatch, useAppSelector } from "@/hooks/redux.ts";
import { fetchAssistant } from "@/store/assistantSlice.ts";
import { ToastState } from "@/components/auth/types/register.types.ts";
import { Toast } from "@/components/ui/Toast.tsx";
import { CsvEditor } from "@/pages/assistants/FilesInScenario/CsvEditor.tsx";
import {Loader} from "@/components/ui/Loaders/Loader.tsx";

function checkIsCsv(text: string) {
    if (!text.includes(",") && !text.includes(";")) return false;

    const rows = text.split(/\r?\n/).filter(row => row.trim() !== "");
    if (rows.length < 2) return false; // Должно быть минимум 2 строки (заголовок + данные)

    const delimiter = text.includes(";") ? ";" : ","; // Определяем разделитель
    const columnCount = rows[0].split(delimiter).length; // Количество столбцов в заголовке

    return rows.every(row => row.split(delimiter).length === columnCount);
}

export const FilesInScenario = () => {
    const [step, setStep] = useState<Step | null>(null);
    const [isCsv, setIsCsv] = useState(false);
    const [toast, setToast] = useState<ToastState>({
        show: false,
        message: '',
        type: 'success'
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [getDataLoading, setGetDataLoading] = useState(true);
    const { id, stepId } = useParams();
    const { assistant } = useAppSelector(state => state.assistant);
    const dispatch = useAppDispatch();

    const saveData = (content: string) => {
        if(id && stepId && step) {
            setIsLoading(true)
            const body = {
                id: Number(stepId),
                name: step.Name,
                assistant_id: Number(id),
                scenario_id: step.ScenarioID,
                operator: step.Operator,
                content,
                step: step.Step,
                context: step.Context
            }
            stepApi.update(body).then(() => {
                setToast({
                    show: true,
                    message: 'Данные успешно сохранены',
                    type: 'success'
                })
            }).catch(() => {
                setToast({
                    show: true,
                    message: 'Произошла ошибка',
                    type: 'error'
                })
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }

    useEffect(() => {
        dispatch(fetchAssistant(Number(id)))
    }, [id]);

    useEffect(() => {
        if(stepId) {
            setGetDataLoading(true);
            stepApi.getOneStep(stepId).then(({ data }) => {
                setIsCsv(checkIsCsv(data.Content))
                setStep(data)
            }).finally(() => {
                setGetDataLoading(false);
            })
        }
    }, []);

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
            {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(prev => ({...prev, show: false}))}
                />
            )}
            <Title>{step?.Name}</Title>
            <Breadcrumbs style={{marginTop: '24px'}}>
                <a href="/dashboard/assistants">Мои ассистенты</a>
                <IoChevronForward size={14} color="#000000"/>
                <a href={`/dashboard/assistants/${id}/scenarios`}>{assistant?.Name}</a>
                <IoChevronForward size={14} color="#000000"/>
                <a href={`/dashboard/assistants/${id}/data`}>Файлы и данные</a>
                <IoChevronForward size={14} color="#000000"/>
                <span>{step?.Name}</span>
            </Breadcrumbs>
            {getDataLoading ? <Loader /> : (
                <ContainerIgnorePadding style={{ background: '#F9F9F9', padding: '27px 45px 20px 44px', flex: 1 }}>
                    {isCsv ? (
                        <CsvEditor content={step?.Content || ''} onSave={saveData} isLoading={isLoading} />
                    ) : (
                        <DocEditor initialValue={step?.Content} onSave={saveData} isLoading={isLoading} />
                    )}
                </ContainerIgnorePadding>
            )}
        </div>
    )
}
